(function(window, angular) {
  "use strict";

  angular.module('service')
  .factory('agenceService', ['baseService', function(baseService) {
    // inherits
    var extended = angular.copy(baseService);
    // url
    extended.base_url = getFullUrl('/api/agence');

    return extended;
  }]);
})(window, window.angular);
